export default [
    {
        subject: "A partial reproduction of Improving Code: The (Mis) Perception of Quality Metrics",
        venue: "ROSE festival at ICSE",
        year: 2019
    },{
        subject: "Improving Source Code Readability: Theory and Practice",
        venue: "International Conference on Program Comprehension (ICPC)",
        year: 2019
    },
]